import { ShieldAlert, FileText } from 'lucide-react';

function WhatsAppTermsContent() {
  return (
    <div className="whatsapp-terms">
      <div className="whatsapp-terms__header">
        <span className="whatsapp-terms__badge" aria-hidden="true">
          <ShieldAlert size={24} />
        </span>
        <div>
          <h3>Termo de Ciência e Responsabilidade</h3>
          <p className="whatsapp-terms__subtitle">
            Leia com atenção antes de conectar o seu WhatsApp à plataforma.
          </p>
        </div>
      </div>

      <div className="whatsapp-terms__content">
        <h4>Antes de continuar, esteja ciente de que:</h4>
        <ul className="whatsapp-terms__list">
          <li>
            O sistema utiliza API não oficial do WhatsApp, podendo violar os termos de uso da Meta/WhatsApp e
            resultar em bloqueio, suspensão ou banimento do número utilizado, sem responsabilidade da Bluezap /
            IpChronus Tecnologia Ltda. Podem ocorrer instabilidades técnicas, como perda de conexão,
            necessidade de nova sincronização ou interrupções temporárias ou permanentes dos serviços, sem
            garantia de continuidade. A Meta/WhatsApp pode alterar regras ou sistemas a qualquer momento,
            tornando a integração parcial ou totalmente inviável. A escolha do número de telefone é de
            responsabilidade exclusiva do Cliente, que assume o risco por eventual perda ou bloqueio. A
            Bluezap / IpChronus Tecnologia Ltda. não possui vínculo com a Meta/WhatsApp e não se
            responsabiliza por perdas financeiras, comerciais ou de qualquer natureza decorrentes de falhas ou
            bloqueios no aplicativo.
          </li>
        </ul>
        <div className="whatsapp-terms__warning" role="note">
          <strong>Atenção:</strong> Ao escanear o QR Code, você declara que leu, compreendeu e aceita
          integralmente os riscos e condições informados acima.
        </div>
      </div>

      <div className="whatsapp-terms__footer">
        <span className="whatsapp-terms__legal">
          <FileText size={16} aria-hidden="true" /> O aceite fica registrado para auditoria.
        </span>
      </div>
    </div>
  );
}

export default WhatsAppTermsContent;
